export default __webpack_public_path__ + "static/media/330_dummy2016-psychotherapie01-mobile-de.8a8e0e7d.png";